<template>
  <van-form class="from-box" @submit="onSubmit">
    <slot></slot>
  </van-form>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {

    }
  },
  methods: {
    onSubmit(values){
      this.$emit('onSubmit', values);
    }
  }
};
</script>

<style lang="less" scoped>
.from-box{

  /deep/ .van-cell{
    background: transparent;
    border: .0625rem solid #0085A0;
    background: #002748;
    border-radius: .5rem;
    margin-bottom: 1rem;
    height: 3.25rem;
    padding: 0 1rem;
    display: flex;
    align-items: center;
  }

  /deep/ .van-popup{
    background: #002748;
  }

  /deep/ .van-field__control{
    color: #E6E9ED;
    font-size: 1rem;

    &::-webkit-input-placeholder { /* webkit, edge, safari, chrome */
      color: #989FAD;
    }
    &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: #989FAD;
      opacity: 1;
    }
    &::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #989FAD;
      opacity: 1;
    }
    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #989FAD;
    }
    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #989FAD;
    }
  }

  /deep/ .mobile{
    .van-field__label{
      width: auto;
      border-right: 1px solid rgba(255, 255, 255, .2);
      padding-right: .75rem;
    }
  }

  /deep/ .code{
    .van-field__button{
      display: flex;
      align-items: center;
    }

  }

  /deep/ .van-button--info{
    // background: linear-gradient(90deg, #61783F 0%, #40839A 100%);
    border: none;
    font-size: 1.125rem;
    font-weight: bold;
    color: #001235 !important;
    opacity: 1;
  }

  /deep/ .amount{
    border: none;
    background: #001235;
    margin-bottom: .75rem;

    .van-field__label{
      width: auto;
      margin-right: .4375rem;
    }

    .van-field__control{
      caret-color: #00E3F9;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FormVant.vue